// extracted by mini-css-extract-plugin
export default {"item":"Item_item__mnxen","head":"Item_head__57wY4","active":"Item_active__luVIs","body":"Item_body__IpW8Y","title":"Item_title__gNIDO"};